import { NEWSLETTER } from "./field-names";
export const defaultValues = {
    [NEWSLETTER]: true
};
